export default __webpack_public_path__ + "static/media/picgray.8a6b884b.png";